const FETCH_LIST = 'auth/prescriptions/fetch_list';
const FETCH_LIST_SUCCESS = 'auth/prescriptions/fetch_list_success';
const FETCH_LIST_FAILED = 'auth/prescriptions/fetch_list_failed';
const FETCH_SIGNED = 'auth/prescriptions/fetch_signed';
const FETCH_SIGNED_SUCCESS = 'auth/prescriptions/fetch_signed_success';
const FETCH_SIGNED_FAILED = 'auth/prescriptions/fetch_signed_failed';
const fetchList = ()=>({
        type: FETCH_LIST
    })
;
const fetchListSuccess = (payload)=>({
        type: FETCH_LIST_SUCCESS,
        payload
    })
;
const fetchListFailed = (error)=>({
        type: FETCH_LIST_FAILED,
        error
    })
;
const fetchSigned = ()=>({
        type: FETCH_SIGNED
    })
;
const fetchSignedSucccess = (payload)=>({
        type: FETCH_SIGNED_SUCCESS,
        payload
    })
;
const fetchSignedFailed = (error)=>({
        type: FETCH_SIGNED_FAILED,
        error
    })
;

export { FETCH_LIST, FETCH_LIST_FAILED, FETCH_LIST_SUCCESS, FETCH_SIGNED, FETCH_SIGNED_FAILED, FETCH_SIGNED_SUCCESS, fetchList, fetchListFailed, fetchListSuccess, fetchSigned, fetchSignedFailed, fetchSignedSucccess };
//# sourceMappingURL=actions.js.map
